import { Component, OnInit, ViewChild, ViewChildren, QueryList} from '@angular/core';
import { IssueElement, Issue } from '../../issues.model';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { Permissions } from '../../../core/services/permissions/permissions.model';
import { IssueElementModalComponent } from '../issue-element-modal/issue-element-modal.component';
import { IssuesRest } from '../../issues.rest';
import { SelectionMode } from '../../../core/shared/grid/grid.model';
import { RichTextComponent } from '../../../core/shared/richtext/richtext.component';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { ShellRestService } from '../../../shell/shell.rest';
@Component({
  selector: 'app-issue-elements',
  templateUrl: './issue-elements.component.html',
  styleUrls: ['./issue-elements.component.scss']
})
export class IssueElementsComponent implements OnInit {

  private get selectionModes() { return SelectionMode; }
  public elements: IssueElement[];
  public assigneeName: string;
  private issue: Issue;
  private isNew: boolean;
  private selectedElementId: number;
  private elementsDescriptions: string;
  private showPreviousDescriptions: boolean;

  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(IssueElementModalComponent) elementModal: IssueElementModalComponent;
  @ViewChildren(RichTextComponent) rowDescriptionViews: QueryList<RichTextComponent>;
  private rowDescriptionView: RichTextComponent = null;

  private headers = [
    { displayName: 'Data', propertyName: 'createdDate', propertyType: 'date', isInitSort: true, dateFormat: 'dd.MM.yyyy HH:mm' },
    { displayName: 'Status', propertyName: 'stateTranslation', propertyType: 'string' },
    { displayName: 'Pracownik', propertyName: 'employeeFullName', propertyType: 'string' },
    { displayName: 'Autor', propertyName: 'createdBy', propertyType: 'string' },
    { displayName: 'Wewn.', propertyName: 'isInternal', propertyType: 'bool' }
  ];

  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionsService.getUserPermissions(claimType);
  }

  constructor(private rest: IssuesRest, private permissionsService: PermissionsService, private shellService: ShellRestService) { }

  ngOnInit() {
    this.shellService.GetLayoutSettings().subscribe(settings => {
      this.showPreviousDescriptions = settings.showPreviousDescriptions;
      if (this.showPreviousDescriptions && this.rowDescriptionView) {
        this.getDescription(this.elementsDescriptions);
      }
    });
  }

  public setModel(issue: Issue, assigneeName: string, isNew: boolean) {
    this.setPermissions('IssueElement');
    this.elements = issue.issueElements;
    this.issue = issue;
    this.assigneeName = assigneeName.split(' (')[0];
    this.isNew = isNew;
    this.concatDescriptions();
  }

  private getActionButtons() {
    return [];
  }

  private addElement() {
    if (!this.issue.customerId) {
      sweetAlert(`Nie wybrano kontrahenta.`);
      return;
    }
    if (!this.issue.assigneeId) {
      sweetAlert(`Nie wybrano osoby odpowiedzialnej.`);
      return;
    }
    this.elementModal.setModel(new IssueElement(), true, this.assigneeName, this.issue);
  }

  private editElement(row: IssueElement) {
    if (!this.issue.customerId) {
      sweetAlert(`Nie wybrano kontrahenta.`);
      return;
    }
    this.elementModal.setModel(row, false, null, this.issue);
  }

  private removeElement(row: IssueElement) {

    if (this.isNew === false && this.elements.length === 1) {
      sweetAlert(`Zgłoszenie musi posiadać elementy.`);
      return;
    }

    sweetAlert('Czy na pewno chcesz usunąć element?', {
      buttons: {
        yes: {
          text: 'Tak',
          value: 'yes'
      },
        no: {
          text: 'Nie',
          value: 'no',
        }
      }
    }).then((value) => {
      switch (value) {
        case 'yes':
          if (row.id != 0 && row.id != undefined) {
            const action = this.rest.removeElement;
            action.call(this.rest, row).subscribe();
          }
          this.elements.splice(this.elements.indexOf(row), 1);
          this.grid.refreshData();
          this.setIssueValuesForLastElement();
          this.concatDescriptions();
          break;
        }});
  }

  public getDescription(row: any) {
    if (this.rowDescriptionView) {
      if (this.showPreviousDescriptions) {
        this.rowDescriptionView.setHtml(this.elementsDescriptions);
      } else {
        if (typeof(row) === 'string') {
          this.rowDescriptionView.setHtml(row);
        } else {
          this.rowDescriptionView.setHtml(row.htmlDescripiton);
        }
      }
      this.rowDescriptionView.disableContol();
    }
    this.rowDescriptionViews.changes.subscribe((nv: QueryList<RichTextComponent>) => {
        this.rowDescriptionView = nv.first;
        if (this.showPreviousDescriptions) {
          this.rowDescriptionView.setHtml(this.elementsDescriptions);
        } else {
          if (typeof(row) === 'string') {
            this.rowDescriptionView.setHtml(row);
          } else {
            this.rowDescriptionView.setHtml(row.htmlDescripiton);
          }
        }
        this.rowDescriptionView.disableContol();
    });
  }

  public onSuccessOperation(value) {
    if (value.isSuccess) {
      if (!value.isNew) {
        const index = this.elements.indexOf(value.element);
        this.elements[index] = value.element;
      } else {
        if (!this.grid.isAsc && this.grid.sortedColumn === 'createdDate') {
          this.elements.unshift(value.element);
        } else {
        this.elements.push(value.element);
        }
      }
      const date = new Date(value.element.createdDate);
      this.elementsDescriptions = `<b> ${date.toLocaleString()} ${value.element.createdBy} </b> <br> <br>`
                                  + value.element.htmlDescripiton + '<br> <br>' + this.elementsDescriptions;
      this.grid.refreshData();
      let element = this.elements.indexOf(value.element);
      this.grid.focusRow(value, element);
      this.grid.selectedItemId = value.element.id;
      this.issue.notAssignedIssue = false;
      this.setIssueValuesForLastElement();
     }
  }

  private previousDescriptionsChange() {
    if (this.showPreviousDescriptions) {
      this.concatDescriptions();
    } else {
      if (!this.grid.focusedRowId) {
        if (this.elements.length > 0) {
          this.selectedElementId = this.elements[0].id;
          this.grid.selectedItemId = this.selectedElementId;
          this.grid.focusedRowId = this.selectedElementId;
          this.grid.focusRow(this.elements[0], 0);
        } else {
          this.getDescription('');
        }
      } else {
        this.getDescription(this.elements.find(x => x.id === this.selectedElementId));
      }
    }
  }

  private concatDescriptions(){
    this.elementsDescriptions = '';
    let previousElements = new Array<IssueElement>();
    if (this.grid && this.grid.focusedRowId) {
      for (const element of this.elements) {
        if (this.issue.issueElements[this.grid.focusedRowId]) {
          if (new Date(element.createdDate).getTime() <= new Date(this.issue.issueElements[this.grid.focusedRowId].createdDate).getTime()) {
            previousElements.push(element);
          }
        }
      }
    } else {
      previousElements = this.elements;
    }
    previousElements.sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
    for (const element of previousElements) {
      let date = new Date(element.createdDate.toLocaleString());
      if (date.toString() == 'Invalid Date') {
        date = new Date(element.createdDate);
      }
      if (element.htmlDescripiton && element.htmlDescripiton.trim() !== '') {
        this.elementsDescriptions += `<b> ${date.toLocaleString()} ${element.createdBy} </b> <br> <br>`;
        this.elementsDescriptions += element.htmlDescripiton + '<br> <br>';
      }
    }

    if (this.issue.htmlDescripiton && this.issue.htmlDescripiton.trim() !== '') {
      const issueStartDate = new Date(this.issue.startDate);
      this.elementsDescriptions += `<b> ${issueStartDate.toLocaleString()} OPIS ZGŁOSZENIA </b> <br> <br>`;
      this.elementsDescriptions += this.issue.htmlDescripiton + '<br> <br>';
    }

    if (this.showPreviousDescriptions) {
      this.getDescription(this.elementsDescriptions);
    } else {
      if (this.elements.length > 0 && this.grid) {
        this.selectedElementId = this.elements[0].id;
        this.grid.selectedItemId = this.selectedElementId;
        this.grid.focusedRowId = this.selectedElementId;
        this.getDescription(this.elements.find(x => x.id === this.selectedElementId));
      } else {
        this.getDescription('');
      }
    }
  }

  private rowFocus(row: any) {
    if (this.showPreviousDescriptions) {
      this.concatDescriptions();
    } else {
      if (row.element) {
        this.getDescription(row.element);
      } else {
        this.getDescription(row);
      }
    }
  }

  private setIssueValuesForLastElement() {
    const lastElement = this.issue.issueElements.sort((a, b) => new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime())[this.issue.issueElements.length-1];
    if (lastElement) {
      this.issue.objectStateId = lastElement.objectStateId;
      this.issue.elementAssignee = lastElement.employeeFullName;
    }
  }
}
